import apiClient from '@/services/axios'

export function createRoutingGroup(routingGroup) {
  return apiClient.post('/routing-groups', routingGroup)
}

export function getRoutingGroups(query) {
  return apiClient.get(`/routing-groups`, {
    params: query,
  })
}

export function getRoutingGroupById(id) {
  return apiClient.get(`/routing-groups/${id}`)
}

export function updateRoutingGroup(routingGroup) {
  return apiClient.patch(`/routing-groups/${routingGroup.id}`, routingGroup)
}

export function deleteRoutingGroup(payload) {
  // cascade: the backend refuses to delete a group that still has active
  // routes unless the caller confirms deleting them together (422 otherwise).
  return apiClient.delete(`/routing-groups/${payload.id}`, {
    params: payload.cascade ? { cascade: 'true' } : {},
  })
}

export function updateRoutingGroupState({ id, ...routingGroup }) {
  return apiClient.patch(`/routing-groups/state/${id}`, routingGroup)
}